/**
 * Sur quelle plateforme tourne Équipote : un navigateur (site, application installée depuis le
 * navigateur), ou une application des stores (iPhone, Android, via Capacitor).
 */
import { Capacitor } from '@capacitor/core';

export const natif = Capacitor.isNativePlatform();
export const plateforme = Capacitor.getPlatform();          // 'web' | 'ios' | 'android'
/** Adresse publique de l'application, pour les liens partagés (WhatsApp, accès…) : jamais l'adresse
 *  interne d'une application mobile. */
export const URL_PUBLIQUE = (process.env.REACT_APP_PUBLIC_URL || (natif ? 'https://app.equipote.fr' : window.location.origin)).replace(/\/$/, '');
